import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyCollectionActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/PropertyCollection/PropertyCollectionBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyCollection"
				RenderedComponent={this.RenderedComponent}
				context="PropertyCollection"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyCollectionActivity)
